import { corsImport } from '@weapp/utils';
import React, { useEffect, useState } from 'react';

interface IProps extends React.Attributes {
  [key: string]: any;
}
export const WithAsyncModuleCom = (
  Com: React.ComponentClass,
  modules: string[],
): React.ComponentType<any> => {
  const _com = (props: IProps) => {
    const hasModules = Array.isArray(modules) && modules.length;
    const [isLoad, setIsLoad] = useState<boolean>(!hasModules);
    useEffect(() => {
      if (hasModules) {
        Promise.all(modules.map((module) => corsImport(module))).then(() => {
          setIsLoad(true);
        });
      }
    }, [props]);
    if (!isLoad) {
      return null;
    }
    return <Com weId={`${props.weId || ''}_9mfyvt`} {...props} />;
  };
  return _com;
};
export default {};
